import { Component, computed, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { ScrollPanel } from 'primeng/scrollpanel';
import { OpkraevningUdestaaendeService } from '../opkraevning-udestaaende.service';
import { OpkraevningUdestaaendeSearchParams } from './opkraevning-udestaaende-search-params.model';
import { Select } from 'primeng/select';
import { ProduktTypeService } from '@shared/services/produkt-type.service';

@Component({
  selector: 'app-opkraevning-udestaaende-search',
  imports: [
    ScrollPanel,
    Button,
    Select,
    ReactiveFormsModule,
    InputText,
    Message,
    CheckboxModule,
  ],
  templateUrl: './opkraevning-udestaaende-search.component.html',
  styleUrl: './opkraevning-udestaaende-search.component.css',
})
export class OpkraevningUdestaaendeSearchComponent {
  opkraevningUdestaaendeService = inject(OpkraevningUdestaaendeService);
  produktTypeService = inject(ProduktTypeService);
  data = this.opkraevningUdestaaendeService.datasource.data;

  form = new FormGroup({
    letsikringNr: new FormControl(),
    haendelsesKode: new FormControl(),
    produktType: new FormControl(),
    regnr: new FormControl(),
    forsikringstagerCpr: new FormControl(),
    clearingsResultatType: new FormControl(),
    status: new FormControl(),
    aarsag: new FormControl(),
  });

  onClickSearch() {
    this.opkraevningUdestaaendeService.searchOpkraevningUdestaaede({
      ...(this.form.value as OpkraevningUdestaaendeSearchParams),
      searchTime: new Date(),
    });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.opkraevningUdestaaendeService.datasource.isLoaded() &&
      this.data()?.totalRowCount == 0
    );
  });

  clearingsResultatTypeOptions = [
    { value: 'ClearingGennemfoert', text: 'Clearing gennemført' },
    { value: 'ClearingFejlet', text: 'Clearing fejlet' },
    { value: 'UdestaaendeClearing', text: 'Udestående clearing' },
  ];

  statusOptions = [
    { value: 'Behandlet', text: 'Behandlet' },
    { value: 'IkkeBehandlet', text: 'Ikke behandlet' },
  ];
}
